import http from '@monolith/legacy/services/api/http';
// oxlint-disable-next-line @typescript-eslint/no-extraneous-class -- used as namespace across codebase
export default class BrandTracking {
  public static track(brandId: number, productId?: number) {
    let body = {};
    if (productId) {
      body = {
        product_id: productId,
      };
    }

    // validateStatus accepts any status so a 401 from CSRF/auth on guest sessions
    // doesn't bubble up to the global reloadOn401 interceptor (which would trigger
    // a page reload loop on public landing pages like /lift/<slug>).
    return http()
      .post(`/api/brands/${brandId}/tracking`, body, { validateStatus: () => true });
  }
}
